import axios from 'axios';
import { store } from '../store';

export const loadLogos = () => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    store.dispatch({ type: 'LOADING_LOGOS' });
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/logo/`,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      store.dispatch({ type: 'LOAD_LOGOS', payload: data });
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      store.dispatch({ type: 'LOADING_LOGOS_ERROR' });
      reject(err);
    });
  });
};

export const loadOrganizations = () => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    store.dispatch({ type: 'LOADING_ORGANIZATIONS' });
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/organization/`,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      store.dispatch({ type: 'LOAD_ORGANIZATIONS', payload: data });
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      store.dispatch({ type: 'LOADING_ORGANIZATIONS_ERROR' });
      reject(err);
    });
  });
};

export const createCarrierLogo = (carrierName, url) => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/logo/`,
      headers: { Authorization: `Token ${token}` },
      data: {
        logo_name: carrierName,
        url,
      },
    }).then(({ data }) => {
      // console.log(data);
      loadLogos();
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      reject(err);
    });
  });
};

export const deleteCarrierLogo = (id) => {
  const { token } = store.getState().auth;
  store.dispatch({ type: 'DELETING_LOGO', payload: true });
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/logo/${id}/`,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      // console.log(data);
      store.dispatch({ type: 'DELETING_LOGO', payload: false });
      loadLogos();
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      store.dispatch({ type: 'DELETING_LOGO', payload: false });
      reject(err);
    });
  });
};

export const updateCarrierLogo = (id, name) => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/logo/${id}/`,
      headers: { Authorization: `Token ${token}` },
      data: {
        display_name: name,
      },
    }).then(({ data }) => {
      // console.log(data);
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      reject(err);
    });
  });
};

export const updateOrganization = (orgId, dataObject) => {
  const { token } = store.getState().auth;
  store.dispatch({ type: 'UPDATING_ORGANIZATION', payload: true });
  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/organization/${orgId}/`,
      headers: { Authorization: `Token ${token}` },
      params: {
        logo: dataObject.logoID ? dataObject.logoID : null,
        display_name: dataObject.displayName ? dataObject.displayName : null,
      },
    }).then(({ data }) => {
      // console.log(data);
      store.dispatch({ type: 'UPDATING_ORGANIZATION', payload: false });
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      store.dispatch({ type: 'UPDATING_ORGANIZATION', payload: false });
      reject(err);
    });
  });
};
